import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Card, CardHeader, CardBody } from 'reactstrap';
import { Form, FormGroup, Input, Button, Spinner } from 'reactstrap';

const QueryFile = () => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            toast.error('Please select a file before uploading.');
            return;
        }

        setLoading(true);
        const apiBaseUrl = process.env.REACT_APP_APIBASE_URL; 
        const formData = new FormData();
        formData.append('sqlFile', file);

        try {
            const response = await axios.post(`${apiBaseUrl}/generate-query-file`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            toast.success('File uploaded successfully!');
            console.log('Response:', response.data);
        } catch (error) {
            toast.error('Failed to upload file. Please try again.');
            console.error('Error uploading file:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='page-content'>
            <Card>
                <CardHeader tag={"h3"}>Upload Query Files</CardHeader>
                <CardBody>
                    <Form>
                        <FormGroup>
                            <Input type='file' onChange={handleFileChange} />
                        </FormGroup>
                        <Button color='primary' onClick={handleUpload} disabled={loading}>
                            {loading ? <Spinner size="sm" /> : 'Upload'}
                        </Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
};

export default QueryFile;